import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledTooltipTitle = styled.div`
  display: flex;
  ${setFontVariant('listItem4', colorsPalettes.bluegrey[100])};
`;

export const StyledTooltipText = styled.div`
  display: flex;
  ${setFontVariant('tooltip', colorsPalettes.bluegrey[100])};
`;

export const StyledUpgradeLink = styled.a`
  display: flex;
  ${setFontVariant('tooltip', colorsPalettes.blue[300])};
  text-decoration: none;
`;
